<template>
  <div>
    <CustomLink
      :url="product.link"
      :type="LINK_TYPE.NoStyle"
      @link-click="handleCardClick"
    >
      <TwicpicsImage
        :src="product.image"
        :alt="imageAlt"
        :width="SIMPLIFIED_CARD.IMAGE_WIDTH"
        :height="SIMPLIFIED_CARD.IMAGE_HEIGHT"
      />
    </CustomLink>
  </div>
</template>

<script lang="ts">


import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import { SIMPLIFIED_CARD } from '~~/constants/productCard';
import { EVENT_SOURCE } from '~~/constants/googleTagManager';
import type { LastSeenProduct } from '~~/types/product/LastSeenProduct';

export default defineComponent({
  name: 'LastSeenProductCard',

  props: {
    product: {
      type: Object as PropType<LastSeenProduct>,
      required: true,
    },
  },
  setup(props) {

    const i18n = useI18n();

    const imageAlt = computed(() => {

      return `${props.product.name} - ${i18n.t('Product Image')}`;
    
    });

    const { trackClickProductBox } = useGtmEvents();

    const handleCardClick = () => {

      trackClickProductBox({
        boxType: EVENT_SOURCE.LAST_SEEN,
        product: {
          sku: props.product.sku,
          name: props.product.name,
          brand: props.product.brand,
          price: props.product.price,
          discountedPrice: props.product.discountedPrice,
          currency: props.product.currency,
          categories: props.product.categories,
        },
      });
    
    };

    return {
      imageAlt,
      LINK_TYPE,
      SIMPLIFIED_CARD,
      handleCardClick,
    };
  
  },
});

</script>
